
import * as actionTypes from './actionTypes';

export const initDevicesStart = () => {
  return {
    type: actionTypes.INIT_DEVICES_START
  };
};
export const resetDevicesState = () => {
  return {
    type: actionTypes.RESET_DEVICES_STATE,
  };
}
export const refreshDevices = (selectedEquipment) => {
  return {
    type: actionTypes.REFRESH_DEVICES,
    selectedEquipment: selectedEquipment
  };
};


export const setDevices = (data) => {
  return {
    type: actionTypes.SET_DEVICES,
    realDevices: data.devices.devices,
    externalPorts: data.devices.externalPortsArray,
    radioInfo: data.devices.radioInfo
  };
};
export const setDevicesByEquipment = (data, selectedEquipment) => {
  return {
    type: actionTypes.SET_DEVICES_BY_EQUIPMENT,
    devicesByEquipment: data.devices.devices,
    selectedEquipment: selectedEquipment
  };
};

export const fetchDevicesFailed = (data) => {
  return {
    type: actionTypes.FETCH_DEVICES_FAILED,
    refresh: data.refresh,
    errorStatus: data.errorStatus
  };
};

export const initDevices = (action = { withPortForwarding: false, selectedEquipment: undefined }) => {
  return {
    type: actionTypes.INIT_DEVICES,
    withPortForwarding: !!action.withPortForwarding ? true : false,
    selectedEquipment: action.selectedEquipment
  };
};
export const getAdvancedDeviceStart = (deviceMac) => {
  return {
    type: actionTypes.GET_ADVANCED_DEVICE_START,
    deviceMac: deviceMac
  };
};
export const getAdvancedIdsStart = () => {
  return {
    type: actionTypes.GET_ADVANCED_IDS_START,
  };
};
export const getAdvancedDevice = (deviceMac, days) => {
  return {
    type: actionTypes.GET_ADVANCED_DEVICE,
    deviceMac: deviceMac,
    days: days
  };
};
export const setAdvancedDevice = (advancedDevice) => {

  return {
    type: actionTypes.SET_ADVANCED_DEVICE,
    advancedDevice: advancedDevice
  };
};
export const changeDeviceName = (deviceName, deviceIcon, devMac, selectedEquipment) => {
  // console.log('selectedEquipment 75::::', selectedEquipment);
  return {
    type: actionTypes.CHANGE_DEVICE_NAME,
    deviceName: deviceName,
    deviceIcon: deviceIcon,
    devMac: devMac,
    selectedEquipment: selectedEquipment
  };
}
export const changeDeviceIcon = (deviceName, deviceIcon, devMac, selectedEquipment) => {
  return {
    type: actionTypes.CHANGE_DEVICE_ICON,
    deviceName: deviceName,
    deviceIcon: deviceIcon,
    devMac: devMac,
    selectedEquipment: selectedEquipment
  };
}
export const changePauseDevice = (enabled, deviceMac, selectedEquipment) => {
  return {
    type: actionTypes.CHANGE_PAUSE_DEVICE,
    enabled: enabled,
    deviceMac: deviceMac,
    selectedEquipment: selectedEquipment
  };
}
export const changeFreezeDevice = (putDelete, deviceMac, templateID, template, selectedEquipment) => {
  return {
    type: actionTypes.CHANGE_FREEZE_DEVICE,
    templateID: templateID,
    template: template,
    putDelete: putDelete,
    deviceMac: deviceMac,
    selectedEquipment: selectedEquipment
  };
}
export const deleteDevice = (deviceMac) => {
  return {
    type: actionTypes.DELETE_DEVICE,
    deviceMac: deviceMac
  };
}

export const deleteFreezesOnDevice = (deviceMac) => {
  return {
    type: actionTypes.DELETE_DEVICE_FREEZES,
    deviceMac: deviceMac
  };
}

export const changeDevicesFailed = () => {
  return {
    type: actionTypes.CHANGE_DEVICES_FAILED
  }
}
export const changeDevicesSuccess = () => {
  return {
    type: actionTypes.CHANGE_DEVICES_SUCCESS
  }
}

export const resetDevicesErrorSuccess = () => {

  return {
    type: actionTypes.RESET_DEVICES_ERROR_SUCCESS
  }
}

export const getAdvancedDeviceIds = (deviceMacs) => {
  //console.log("getAdvancedDeviceIds actions", deviceMacs);
  return {
    type: actionTypes.GET_ADVANCED_DEVICE_IDS,
    deviceMacs: deviceMacs
  };
};

export const setAdvancedDeviceIds = (advancedDeviceIds) => {
  //console.log("setAdvancedDeviceIds actions", advancedDeviceIds);
  return {
    type: actionTypes.SET_ADVANCED_DEVICE_IDS,
    advancedDeviceIds: advancedDeviceIds
  };
};

export const reportAdidIssue = (issueType, deviceMac, deviceName, incorrectProperty, message) => {
  // console.log("reportAdidIssue actions", deviceMac);
  return {
    type: actionTypes.REPORT_ADID_ISSUE,
    deviceMac: deviceMac,
    deviceName: deviceName,
    issueType: issueType,
    incorrectProperty: incorrectProperty,
    message: message
  };
};

export const reportAdidIssueFailed = () => {
  return {
    type: actionTypes.REPORT_ADID_ISSUE_FAILED
  }
}
export const reportAdidIssueSuccess = () => {
  return {
    type: actionTypes.REPORT_ADID_ISSUE_SUCCESS
  }
}

export const resetAdidIssueErrorSuccess = () => {

  return {
    type: actionTypes.RESET_ADID_ISSUE_ERROR_SUCCESS
  }
}

export const setActivitySelectedDeviceDetails = (deviceDetails) => ({
  type: actionTypes.ACTIVITY_SELECTED_DEVICE_DETAILS,
  deviceDetails
})





